/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Allowed login factor.
 * 
 * `hook` is a placeholder rather than a real factor: the organization's `identify_user`
 * synchronous webhook decides the actual factor (and possibly the organization). When no
 * webhook resolves a factor for the identifier, `POST /id/v2` answers 401 and the caller
 * should fall back to offering regular factors. `hook` takes no options and is only
 * meaningful on `POST /id/v2`.
 * @export
 */
export const FactorMethod = {
    Webauthn: 'webauthn',
    EmailLink: 'email_link',
    SmsLink: 'sms_link',
    OtpViaSms: 'otp_via_sms',
    OtpViaEmail: 'otp_via_email',
    Totp: 'totp',
    Oidc: 'oidc',
    Saml: 'saml',
    Api: 'api',
    DirectId: 'direct_id',
    Password: 'password',
    Impersonate: 'impersonate',
    Anonymous: 'anonymous',
    Hook: 'hook'
} as const;
export type FactorMethod = typeof FactorMethod[keyof typeof FactorMethod];


export function instanceOfFactorMethod(value: any): boolean {
    for (const key in FactorMethod) {
        if (Object.prototype.hasOwnProperty.call(FactorMethod, key)) {
            if (FactorMethod[key as keyof typeof FactorMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FactorMethodFromJSON(json: any): FactorMethod {
    return FactorMethodFromJSONTyped(json, false);
}

export function FactorMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): FactorMethod {
    return json as FactorMethod;
}

export function FactorMethodToJSON(value?: FactorMethod | null): any {
    return value as any;
}

export function FactorMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): FactorMethod {
    return value as FactorMethod;
}

